import React, { useState, useEffect} from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import BannerHome from '../components/Home/BannerHome';
import '../views/Home.scss';
import TransactionDetails from '../components/Home/TransactionDetails_new';
import ServiceOffered from '../components/Home/ServiceOffered';
import Questions from '../components/Home/Questions';
import Header from '../components/common/header';
import Clients from '../components/Home/Clients';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import AppFooter from '../components/common/footer';
import { Layout } from 'antd';
import Gallery from '../components/Home/Gallery';

const { Content, Footer } = Layout;

export type Section =
  | "home"
  | "transaction"
  | "services"
  | "clients"
  | "questions"
  | "registrationform";

function AppHome() {
  const location = useLocation();
  const navigate = useNavigate();
  const [active, setActive] = useState<Section>("home");
  
useEffect(() => {
if (location.hash) {
      const hash = location.hash.replace("#", "") as Section;
      const el = document.getElementById(hash);
      if (el) {
        el.scrollIntoView({ behavior: "smooth" });
        setActive(hash);
        return;
      } else {
        // If user is on /registrationform and clicked /#faq
        navigate("/#faq"); // redirect to homepage with hash
        return;
      }
    }
    // Otherwise, detect section based on scroll
    const sections = document.querySelectorAll("section");

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setActive(entry.target.id as Section);
          }
        });
      },
      { threshold: 0.5 }
    );

    sections.forEach((section) => observer.observe(section));
    return () => observer.disconnect();
  }, [location.pathname]); // run again if route changes

    //     useEffect(() => {
    //   const sessionTimeoutMessege = localStorage.getItem('sessionTimeoutMessege');
  
    //   if (sessionTimeoutMessege === 'true') {
    //     // Show the toast when `messege` is true
    //     toast.error(
    //       <div style={{ display: 'flex', alignItems: 'center' }}>
    //         {/* <FaExclamationCircle style={{ marginRight: '10px', fontSize: '24px' }} /> */}
    //         <span style={{ fontSize: '16px', fontWeight: 'bold' }}>
    //           Your session has timed out. Please log in again to continue.
    //         </span>
    //       </div>,
    //       {
    //         position: 'top-center', // Position in the top center
    //         autoClose: false,  // Auto close after 6 seconds
    //         hideProgressBar: true,  // Hide the progress bar
    //         style: {
    //           backgroundColor: '#5530f5',  // Red background color
    //           color: 'white',  // White text color
    //           borderRadius: '10px',  // Rounded corners
    //           padding: '15px',  // More padding for better spacing
    //           fontSize: '16px',  // Clearer font size
    //           fontWeight: 'bold',  // Bold text for emphasis
    //         },
    //         icon: false,  // Disable default icon since we're using a custom one
    //       }
    //     );
  
    //     localStorage.setItem('sessionTimeoutMessege', 'false');
  
    //     // setMessege(false);
    //   }
    // }, []);

  return (
    <>
    <ToastContainer />
    <div className="main">
      <Header active={active}/>
      <BannerHome />
      {/* <TransactionDetails /> */}
      <ServiceOffered />
      <Clients />
      {/* <Gallery /> */}
      <Questions />
        <Footer>
          <AppFooter />
        </Footer>
      {/* <AppFaq/>
      <AppPricing/>
      <AppContact/> */}
    </div>
    </>
  );
}

export default AppHome;